<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">{{ title }}</h1>
    <el-row :gutter="10" class="user-options">
      <!-- hostRid,countryCode -->
      <el-col :span="4">
        <el-input
          v-model="queryData.hostRid"
          placeholder="主播RID,多个RID,分隔"
          clearable
          style="width: 100%"
        />
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="queryData.countryCode"
          placeholder="请选择国家"
          clearable
          filterable
          style="width: 100%"
        >
          <el-option
            v-for="item in video_countries"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="queryData.recommended"
          placeholder="是否推荐"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in recommendedOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-button type="primary" @click="getList" :loading="login1"> 查询 </el-button>
      <el-button type="warning" @click="dialogVisible_host = true"> 新增 </el-button>
    </el-row>
    <el-row class="user-options">
      <el-table :data="list" v-loading="login1" border>
        <el-table-column prop="hostUid" label="RID" align="center" />
        <el-table-column prop="hostRid" label="ID" align="center" />
        <el-table-column prop="hostCountry" label="国家" align="center" />
        <el-table-column prop="recommended" label="是否推荐" align="center">
          <template slot-scope="scope">
            <!-- scope.row.recommended 1推荐,0不推荐  -->
            <el-tag v-if="scope.row.recommended > 0" type="success">已推荐</el-tag>
            <el-tag v-else type="danger">未推荐</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="mtime" label="最后一次推荐的时间" align="center">
          <template slot-scope="scope">
            <span>{{ format_(scope.row.mtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="showVideoList(scope.row)">
              查看视频详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageInfo.page"
        :page-size="20"
        layout="total, prev, pager, next"
        :total="pageInfo.total"
      >
      </el-pagination>
    </el-row>

    <el-dialog
      title="视频列表"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <el-table :data="video_list" v-loading="login1" border>
        <el-table-column type="index" label="序号" align="center" width="50" />
        <el-table-column prop="hostRid" label="RID" align="center" />
        <el-table-column prop="hostCountry" label="主播国家" align="center" />
        <el-table-column prop="duration" label="通话时长(s)" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.duration }}s</span>
          </template>
        </el-table-column>
        <el-table-column prop="mtime" label="通话时间" align="center">
          <template slot-scope="scope">
            <span>{{ format_(scope.row.mtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="recommended" label="设为推荐视频" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.recommended == 1" type="success">已设定</el-tag>
            <el-tag v-else type="danger">未设为</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot-scope="scope">
            <div class="btns">
              <!-- <el-button type="primary" size="small" @click="playVideo(scope.row.url)">
                播放视频
              </el-button> -->
              <el-button type="primary" size="small" @click="copy(scope.row.url)">
                查看视频
              </el-button>
              <el-button
                style="margin-left: 0"
                v-if="scope.row.recommended == 0"
                type="primary"
                size="small"
                @click="edit(scope.row)"
              >
                设为推荐视频
              </el-button>
              <el-button
                style="margin-left: 0"
                v-else
                type="primary"
                size="small"
                @click="edit(scope.row)"
              >
                取消设定
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleVideoCurrentChange"
        :current-page.sync="videoPageInfo.page"
        :page-size="20"
        layout="total, prev, pager, next"
        :total="videoPageInfo.total"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>

      <div v-show="vid" class="po">
        <i @click="look_()" class="el-icon-circle-close pos" style="z-index: 9999"></i>
        <video
          id="video"
          preload="auto"
          size="medium"
          type="application/x-mpegURL"
          src=""
          controls
          class="video-js vjs-default-skin"
          style="width: 480px; height: 740px; object-fit: container"
        ></video>
      </div>
    </el-dialog>
    <el-dialog
      title="增加指定主播"
      :visible.sync="dialogVisible_host"
      width="60%"
      :before-close="handleClose"
    >
      <!-- 一个input，输入rid，用,分隔 -->
      <el-input
        v-model="hostSet"
        placeholder="请输入主播ID，多个ID用,分隔"
        clearable
        style="width: 100%"
      />

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_host = false">取 消</el-button>
        <el-button type="primary" @click="addHost">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
import { getCountry } from "@/utils/normalApi.js";
import useClipboard from "vue-clipboard3";
const { toClipboard } = useClipboard();

export default {
  props: {
    title: {
      type: String,
      default: '推荐视频'
    }
  },
  data() {
    return {
      vid: false,
      dialogVisible: false,
      dialogVisible_host: false,
      queryData: {
        hostRid: "",
        countryCode: "",
        recommended: "null",
      },
      recommendedOptions: [
        {
          value: "null",
          label: "全部",
        },
        {
          value: "0",
          label: "不推荐",
        },
        {
          value: "1",
          label: "推荐",
        },
      ],
      hostSet: "",
      list: [],
      pageInfo: {
        page: 1,
        total: 0,
      },
      videoPageInfo: {
        page: 1,
        total: 0,
      },
      // 加载
      login1: false,
      video_countries: [],
      // countries: [],
      video_list: [],
      selectHostRid: "",
    };
  },
  created() {
    this.getList();
    this.getVideoCountry();
  },
  methods: {
    async copy(value) {
      window.open(value);
      // try {
      //   await toClipboard(value);
      //   this.$message.success("Copied successfully");
      // } catch (e) {
      //   console.error(e);
      // }
    },
    async addHost() {
      this.login1 = true;
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.video_recommend_host_add +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        {
          hostSet: this.hostSet,
        }
      );
      this.login1 = false;
      if (res.code != 0) return this.$message(res.msg);
      this.$message.success("添加成功");
      this.dialogVisible_host = false;
      this.getList();
    },
    showVideoList(item) {
      this.dialogVisible = true;
      this.videoPageInfo.page = 1;
      this.videoPageInfo.total = 0;
      this.selectHostRid = item.hostRid;
      this.getVideoList();
    },
    handleClose() {
      this.dialogVisible = false;
      this.selectHostRid = "";
      this.dialogVisible_host = false;
      this.hostSet = "";
      this.video_list = [];
      this.look_();
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getList();
    },
    handleVideoCurrentChange(val) {
      this.videoPageInfo.page = val;
      this.getVideoList();
    },
    // 查询列表
    async getList() {
      this.login1 = true;
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.video_recommend_host_list +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token +
          "&page=" +
          this.pageInfo.page,
        this.queryData
      );
      this.login1 = false;
      if (res.code != 0) return this.$message(res.msg);
      this.list = res.data.list;
      this.pageInfo.total = res.data.totalCount;
    },
    playVideo(url) {
      console.log(url);

      this.vid = true;
      setTimeout(() => {
        let myPlayer = videojs("video"); //获取video的id值
        myPlayer.src({ type: this.getMimeType(url), src: url });
        myPlayer.load(url);

        myPlayer.play().catch((error) => {
          console.error("Video playback failed:", error);
          this.resetPlayer();
          this.vid = false; // 隐藏播放器
        });
      }, 1000);
    },
    look_() {
      this.vid = false;
      this.resetPlayer();
    },
    resetPlayer() {
      let myPlayer = videojs("video"); //获取video的id值
      myPlayer.pause();
      myPlayer.reset(""); // 清空视频源，重置播放器
    },
    getMimeType(url) {
      if (url.endsWith(".mp4")) {
        return "video/mp4";
      } else if (url.endsWith(".m3u8")) {
        return "application/x-mpegURL";
      }
      return "video/mp4";
    },
    async getVideoList() {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.video_recommend +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token +
          "&page=" +
          this.videoPageInfo.page,
        {
          hostRid: this.selectHostRid,
        }
      );
      if (res.code != 0) return this.$message(res.msg);
      this.video_list = res.data.list;
      this.videoPageInfo.total = res.data.totalCount;
    },
    async edit(item) {
      this.$confirm("确定将此视频设为推荐视频?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          item.recommended = item.recommended == 0 ? 1 : 0;
          const { data: res } = await this.$axios.post(
            this.$store.getters.path.video_recommend_update +
              "?username=" +
              this.$store.getters.username +
              "&token=" +
              this.$store.getters.token +
              "&page=" +
              this.pageInfo.page,
            {
              data: {
                ...item,
              },
            }
          );
          if (res.code != 0) {
            item.recommended = item.recommended == 0 ? 1 : 0;
            return this.$message(res.msg);
          }
          this.$message.success("设置成功");
          this.getList();
          this.getVideoList();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消设置",
          });
        });
    },
    async getVideoCountry() {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.video_country +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token +
          "&page=" +
          this.pageInfo.page,
        {}
      );
      if (res.code != 0) return this.$message(res.msg);
      this.video_countries = res.data.list;
    },
    format_(data) {
      let date = new Date(data * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
        "-";
      let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
.po {
  width: 480px;
  height: 640px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index:999;
}

.pos {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: -50px;
  transform: scale(2);
}
.btns{
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  button{
    margin:0;
  }
}
</style>
